import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import MainContainer from "../../components/MainContainer";
import Heading from "../../components/Heading";
import { Paper, Tooltip, IconButton, Typography } from "@material-ui/core";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import SongListTable from "../../components/songListTable/SongListTable";

const helpText = (
    <div style={{ padding: 8, maxWidth: 300 }}>
        <p style={{ margin: "0 0 8px 0" }}>
            Use this section to create your master song list. If you have audio or video of you performing this song, add it using the Media URL field. Select 12 songs for your Top 12 which will appear on your public facing profile.
        </p>
        <p style={{ margin: 0 }}>
            <strong>Tip:</strong> Be sure to spell the song title and artist names correctly!
        </p>
    </div>
);

@inject("songListStore", "profileStore")
@observer
class SongList extends Component {
    render() {
        const { currentProfile } = this.props.profileStore;

        return (
            <main>
                <Header />
                <Sidebar />
                <MainContainer>
                    <Heading title="My Song List" />
                    <Paper style={{ padding: 16 }}>
                        <div style={{ display: "flex", alignItems: "center", marginBottom: 16 }}>
                            <Typography variant="headline" component="h3">
                                Song List
                            </Typography>
                            <Tooltip title={helpText} placement="bottom-start" interactive>
                                <IconButton style={{ marginLeft: 8, padding: 4 }}>
                                    <HelpOutlineIcon style={{ color: "#555" }} />
                                </IconButton>
                            </Tooltip>
                        </div>
                        {currentProfile && (
                            <SongListTable
                                onListAdd={this.handleAddSongList}
                                onListRemove={this.handleRemoveSong}
                                onListSort={this.handleSortSongList}
                                label="Song List"
                                profileId={currentProfile.id}
                                type="musician"
                            />
                        )}
                    </Paper>
                </MainContainer>
            </main>
        );
    }
}

export default SongList;
